import React, { useState, useEffect } from 'react';
import TenureForm from './TenureForm';
import { useHistory } from 'react-router-dom';
import { setTenureValue } from '../dashboardAction';
import { useDispatch, useSelector } from 'react-redux';
import RoundButton from '../../../../Common/RoundButton';
import { logFirebaseEvent } from '../../firebase';
import { P2P_INVEST_NOW_BTN } from '../../firebase/constant';
import { Typography } from '@material-ui/core';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import BackgroundTheme from '../../../../Common/P2P/Header/BackgroundTheme';
import TenureIcon01 from '../../../../utils/assests/tenure-icon-01.png';
import TenureIcon02 from '../../../../utils/assests/tenure-icon-02.png';
import TenureIcon03 from '../../../../utils/assests/tenure-icon-03.png';
import TenureIcon04 from '../../../../utils/assests/tenure-icon-04.png';
import TenureIcon05 from '../../../../utils/assests/tenure-icon-05.png';
import Box from '@mui/material/Box';
function Tenure() {
  const history = useHistory();
  let dispatch = useDispatch();
  const { amountInput } = useSelector((state: any) => state.dashboard);
  const [setReturnValue, returnValue] = useState({
    id: 3,
    expectedReturns: 8.60,
    tenureImg: TenureIcon02,
    message: 'p.a.',
  });

  const [returnData, setReturnData] = useState([
    { id: 3, expectedReturns: 8.60, isSelected: true, tenureImg: TenureIcon01,message: 'p.a.', },
    { id: 6, expectedReturns: 9, isSelected: false, tenureImg: TenureIcon02,message: 'p.a.', },
    {
      id: 12,
      expectedReturns: 9.25,
      isSelected: false,
      tenureImg: TenureIcon03,
      message: 'p.a.',
    },
    { id: 24, expectedReturns: 10, isSelected: false, tenureImg: TenureIcon04 ,message: 'S.I.',},
    {
      id: 36,
      expectedReturns: 10,
      isSelected: false,
      tenureImg: TenureIcon05,
      message: 'S.I.',
    },
  ]);

  const onClickMonth = (month: number) => {
    const expReturnValue = [...returnData];
    const returnValueData = expReturnValue.find((r: any) => r.id === month);
    for (let i = 0; i < expReturnValue.length; i++) {
      if (expReturnValue[i].id === month) expReturnValue[i].isSelected = true;
      else expReturnValue[i].isSelected = false;
    }
    if (returnValueData) {
      if (returnValueData?.isSelected) {
        dispatch(setTenureValue(returnValueData?.id));
        returnValue(returnValueData);
      }
    }
    setReturnData(expReturnValue);
    return true;
  };

  const confirmInvestment = () => {
    logFirebaseEvent(P2P_INVEST_NOW_BTN);
    history.push({
      pathname: '/p2p/investFund',
    });
  };

  useEffect(() => {
    const expReturnValue = [...returnData];
    expReturnValue.map((item) => {
      if(item.isSelected){
        dispatch(setTenureValue(item?.id));
      }
    })
  },[])

  return (
    <>
      <BackgroundTheme>
        <Card className='redBorder'>
          <CardContent>
            <TenureForm
              setReturnValue={setReturnValue}
              returnData={returnData}
              onClickMonth={onClickMonth}
              amountInput={amountInput}
            />
          </CardContent>
        </Card>
        <Box className='cardBottomText'>
          <Typography>
            You will only be able to withdraw your <br /> investment after the
            holding period
          </Typography>
          <Typography> Each investment is subject to risk</Typography>
        </Box>
        <div className='tenure-button-styles'>
          <RoundButton title='Invest now' onClick={confirmInvestment} />
        </div>
      </BackgroundTheme>
    </>
  );
}
export default Tenure;
